import { Switch, SwitchProps } from '@fx-ui/fine-design';
import React from 'react';
import { useLoading } from '@libs/shared';

interface AsyncSwitchProps extends SwitchProps {
    onAsyncChange: (state: boolean) => Promise<any> | void;
}

/**
 * 异步请求的switch (受控)
 * @param root0
 * @param root0.onAsyncChange
 */
const AsyncSwitch: React.FC<AsyncSwitchProps> = ({ onAsyncChange, ...props }) => {
    const [loading, handleLoadingChange, loadingRef] = useLoading();
    return (
        <Switch
            {...props}
            loading={loading}
            onChange={(state) => {
                if (loadingRef.current) {
                    return;
                }
                const res = onAsyncChange(state);
                if (!res) {
                    return;
                }
                handleLoadingChange(true);
                res.finally(() => handleLoadingChange(false));
            }}
        />
    );
};

export default AsyncSwitch;
